module.exports = __webpack_public_path__ + "media/cuttlefish/activeProBadge-78c95393.svg";